import * as React from "react";
import { forwardRef } from "react";
const SvgProperties = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white", fillOpacity: 0.01 }), /* @__PURE__ */ React.createElement("path", { d: "M6 2C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2H6ZM13 9V3.5L18.5 9H13Z", fill: "#A1A1A1" }));
const ForwardRef = forwardRef(SvgProperties);
export default ForwardRef;
